import { Button } from "components/ui/button";
import { useStore } from "hooks/use-store";
import { useRef, useState } from "react";
import { UsbTransferModal } from "../modals/usb-transfer-modal/usb-transfer-modal";
import { SettingsSection } from "../components/settings-section";
import { useTranslation } from "react-i18next";
import { TabContainer } from "../components/tab-container";
import { ScrollButtons } from "components/ui/scroll-buttons";
import { Download } from "lucide-react";

export const DataExport = ({ title }) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "settings",
  });

  const config = useStore((state) => state.config);

  const ref = useRef<HTMLDivElement>(null);

  const [showDownloadModal, setShowDownloadModal] = useState(false);

  return (
    <TabContainer ref={ref} title={title} className="space-y-2">
      <ScrollButtons containerRef={ref} className="absolute bottom-4 right-4" />
      {config?.has_usb_transfer && (
        <SettingsSection
          label={t("general_settings.usb_data_transfer.title")}
          description={t("general_settings.usb_data_transfer.description")}
          content={
            <Button
              onClick={() => setShowDownloadModal(true)}
              variant="secondary"
            >
              <Download className="w-5 h-5 mr-2" />
              {t("general_settings.usb_data_transfer.button")}
            </Button>
          }
        />
      )}
      <SettingsSection
        label={t("system_status.data_download.website_url")}
        description={t("system_status.data_download.description")}
        content={<p>{`${window.location.origin}/download`}</p>}
        horizontal={false}
      />
      <UsbTransferModal
        show={showDownloadModal}
        onClose={() => setShowDownloadModal(false)}
      />
    </TabContainer>
  );
};
